import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { projectsApi } from './api/projectsApi';
import { ProjectPicker, validateProject } from './components/ProjectPicker';

const projectPickerFormField = FormFieldBlueprint.make({
  name: 'project-picker',
  params: {
    field: async () =>
      createFormField({
        name: 'ProjectPicker',
        component: ProjectPicker,
        validation: validateProject,
      }),
  },
});

export const projectPickerScaffolderModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [projectsApi, projectPickerFormField],
});
